(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["case-study-mockup-b"]) return;
  try {
    
  // Signature moment: stats count up + spec ledger draws itself — both scoped, deterministic,
  // IntersectionObserver-driven (Horizon Web-Component pattern), reduced-motion + no-JS safe.
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class CsBStats extends HTMLElement {
      connectedCallback() {
        if (reduce) return; // leave final numbers static
        var nums = this.querySelectorAll('[data-count]');
        for (var i = 0; i < nums.length; i++) {
          var el = nums[i].querySelector('.cs-b__num');
          if (el) el.textContent = '0';
        }
        var observer = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            obs.unobserve(entry.target);
            countUp(entry.target);
          });
        }, { threshold: 0.5 });
        nums.forEach(function (n) { observer.observe(n); });
      }
    }

    function countUp(valueEl) {
      var target = parseInt(valueEl.getAttribute('data-count'), 10);
      var numEl = valueEl.querySelector('.cs-b__num');
      if (!numEl) return;
      var duration = 1100;
      var startTime = null;
      function frame(now) {
        if (startTime === null) startTime = now;
        var progress = Math.min((now - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        numEl.textContent = Math.round(target * eased).toString();
        if (progress < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    class CsBLedger extends HTMLElement {
      connectedCallback() {
        if (reduce) return;
        this.classList.add('cs-ready');
        var self = this;
        var observer = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            obs.unobserve(entry.target);
            self.classList.add('is-drawn');
          });
        }, { threshold: 0.25 });
        observer.observe(this);
      }
    }

    if (!customElements.get('cs-b-stats')) customElements.define('cs-b-stats', CsBStats);
    if (!customElements.get('cs-b-ledger')) customElements.define('cs-b-ledger', CsBLedger);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-study-mockup-e"]) return;
  try {
    
  // Signature moment: stats count up + spec ledger draws itself — both scoped, deterministic,
  // IntersectionObserver-driven (Horizon Web-Component pattern), reduced-motion + no-JS safe.
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class CsEStats extends HTMLElement {
      connectedCallback() {
        if (reduce) return; // leave final numbers static
        var nums = this.querySelectorAll('[data-count]');
        for (var i = 0; i < nums.length; i++) {
          var el = nums[i].querySelector('.cs-e__num');
          if (el) el.textContent = '0';
        }
        var observer = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            obs.unobserve(entry.target);
            countUp(entry.target);
          });
        }, { threshold: 0.5 });
        nums.forEach(function (n) { observer.observe(n); });
      }
    }

    function countUp(valueEl) {
      var target = parseInt(valueEl.getAttribute('data-count'), 10);
      var numEl = valueEl.querySelector('.cs-e__num');
      if (!numEl) return;
      var duration = 1100;
      var startTime = null;
      function frame(now) {
        if (startTime === null) startTime = now;
        var progress = Math.min((now - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        numEl.textContent = Math.round(target * eased).toLocaleString('en-US');
        if (progress < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    class CsELedger extends HTMLElement {
      connectedCallback() {
        if (reduce) return;
        this.classList.add('cs-ready');
        var self = this;
        var observer = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            obs.unobserve(entry.target);
            self.classList.add('is-drawn');
          });
        }, { threshold: 0.25 });
        observer.observe(this);
      }
    }

    if (!customElements.get('cs-e-stats')) customElements.define('cs-e-stats', CsEStats);
    if (!customElements.get('cs-e-ledger')) customElements.define('cs-e-ledger', CsELedger);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
